import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { Grid, Typography, LinearProgress, Button, Chip, Stop, Replay, } from '@vitessce/styles';
function useStatusChipProps(isLoading, stillRef, noNewRequests, initializing) {
    // Determine status
    let statusColor = 'default';
    let statusLabel = 'Idle';
    if (initializing) {
        statusColor = 'warning';
        statusLabel = 'Initializing';
    }
    else if (isLoading) {
        statusColor = 'primary';
        statusLabel = 'Loading Data';
    }
    else if (stillRef) {
        statusColor = 'success';
        statusLabel = 'High Quality';
    }
    else if (noNewRequests) {
        statusColor = 'warning';
        statusLabel = 'Loading Stopped';
    }
    else {
        statusColor = 'success';
        statusLabel = 'Ready';
    }
    return { statusColor, statusLabel };
}
function StatusChip({ label, color }) {
    return (_jsx(Chip, { label: label, color: color, size: "small" }));
}
function LoadingControlButton({ startIcon, onClick, disabled, ariaLabel, children }) {
    return (_jsx(Button, { size: "small", variant: "outlined", startIcon: startIcon, onClick: onClick, disabled: disabled, "aria-label": ariaLabel, fullWidth: true, children: children }));
}
function LoadingText({ bricksLoaded, currentRequestCount, totalBricksRequested, isLoading }) {
    return (_jsxs(Typography, { variant: "body2", children: ["Bricks loaded: ", bricksLoaded, isLoading && totalBricksRequested > 0 && ` (${totalBricksRequested - currentRequestCount}/${totalBricksRequested})`] }));
}
export default function LoadingStatusIndicator(props) {
    const { loadingProgress, onStopLoading, onRestartLoading, stillRef, spatialRenderingMode, } = props;
    const { bricksLoaded = 0, currentRequestCount = 0, totalBricksRequested = 0, isLoading = false, percentage = 0, noNewRequests = false, } = loadingProgress || {};
    const initializing = !loadingProgress || (bricksLoaded === 0 && totalBricksRequested === 0);
    const { statusColor, statusLabel } = useStatusChipProps(isLoading, stillRef, noNewRequests, initializing);
    // Only show in 3D mode
    const is3dMode = spatialRenderingMode === '3D';
    if (!is3dMode || !loadingProgress) {
        return null;
    }
    return (_jsxs(Grid, { container: true, px: 0.5, children: [_jsx(Grid, { size: 6, alignItems: "start", children: _jsx(Grid, { container: true, alignItems: "center", gap: 1, children: statusColor !== 'success' ? (_jsx(StatusChip, { label: statusLabel, color: statusColor, size: "small" })) : null }) }), _jsx(Grid, { size: 6, px: 1, my: 0.25, children: _jsx(LoadingText, { bricksLoaded: bricksLoaded, currentRequestCount: currentRequestCount, totalBricksRequested: totalBricksRequested, isLoading: isLoading }) }), _jsx(Grid, { size: 12, children: _jsxs(Grid, { container: true, direction: "row", spacing: 2, alignItems: "center", wrap: "nowrap", children: [_jsx(LoadingControlButton, { startIcon: _jsx(Stop, {}), onClick: onStopLoading, disabled: noNewRequests, ariaLabel: "Stop loading data and render at highest resolution", children: "Stop\u00A0Loading" }), _jsx(LoadingControlButton, { startIcon: _jsx(Replay, {}), onClick: onRestartLoading, disabled: !noNewRequests && !isLoading, ariaLabel: "Restart data loading", children: "Restart\u00A0Loading" })] }) }), _jsx(Grid, { size: 12, visibility: isLoading ? 'visible' : 'hidden', mt: 1, mb: 0.5, children: _jsx(LinearProgress, { variant: "determinate", value: percentage }) })] }));
}
//# sourceMappingURL=LoadingStatusIndicator.js.map